import _ from "lodash";
import IDUtils from "../utils/IDUtils";

class PageUpdate {
  constructor(pageId) {
    this.id = pageId; //page id
    this.updates = [];
  }

  add(propPath, value, updateAction, addUndo, source) {
    const key = _.isArray(propPath) ? propPath : IDUtils.getArray(propPath);
    let action = false;

    //allow normal update action to be overwritten
    if (updateAction) {
      action = updateAction;
    }

    var update = {
      key,
      value,
      action,
      addUndo,
      source,
    };

    this.updates.push(update);
  }
}

export default PageUpdate;
